<script>
import { useAccount } from 'dashboard/composables/useAccount';
import { mapGetters } from 'vuex';
import { FEATURE_FLAGS } from 'dashboard/featureFlags.js';

import ExecuteCardAutomationDialog from '../ExecuteCardAutomation/ExecuteCardAutomationDialog.vue';
import ButtonNext from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    ButtonNext,
    ExecuteCardAutomationDialog,
  },
  props: {
    board: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Object,
      default: () => {},
    },
    card: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const { accountId } = useAccount();

    return {
      accountId,
    };
  },
  computed: {
    ...mapGetters({
      isFeatureEnabledonAccount: 'accounts/isFeatureEnabledonAccount',
      automations: 'wgptBoards/getBoardAutomations',
      boardsUiFlags: 'wgptBoards/getUIFlags',
    }),
    isFeatureEnabled() {
      return this.isFeatureEnabledonAccount(
        this.accountId,
        FEATURE_FLAGS.WGPT_AUTOMATIONS
      );
    },
    isNotLoading() {
      return !this.boardsUiFlags.isLoading;
    },
    isNotEmpty() {
      return this.automations.length > 0;
    },
  },
  methods: {
    openConfirmDialog(automation) {
      this.$refs.executeCardAutomationDialogRef.open(automation);
    },
  },
};
</script>

<template>
  <div v-show="isFeatureEnabled && isNotLoading && isNotEmpty">
    <div class="flex justify-between mt-5">
      <label>
        {{ $t('WGPT_BOARDS.ITEM.LIST.CARD.EDIT.SIDEBAR.AUTOMATION.LABEL') }}
      </label>
    </div>
    <ul class="list-none ml-0 mb-0 flex flex-col gap-1.5">
      <ButtonNext
        v-for="automation in automations"
        :key="automation.id"
        v-tooltip.left="{
          content: automation.description,
          triggers: ['hover'],
          popperClass: 'wgpt-boards-automation-button-tooltip',
          autoHide: true,
          container: false,
          delay: { show: 500, hide: 0 },
        }"
        :label="automation.name"
        size="sm"
        variant="faded"
        color="slate"
        icon="i-lucide-workflow"
        :disabled="disabled || !automation.active"
        class="w-full !justify-start"
        @click="openConfirmDialog(automation)"
      />
    </ul>

    <ExecuteCardAutomationDialog
      ref="executeCardAutomationDialogRef"
      :board="board"
      :list="list"
      :card="card"
    />
  </div>
</template>

<style lang="scss">
.wgpt-boards-automation-button-tooltip {
  max-width: 300px;
  white-space: wrap;
}
</style>
